/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Omit<WorkExperiencePosition, \'id\' | \'jobPositionId\'>, schemaOptions: { exclude: [ \'id\', \'jobPositionId\' ] })
 */
export interface WorkExperiencePositionExcludingIdJobPositionId { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    lastArea?: string;
    lastAreaYears?: number;
    lastPosition?: string;
    lastPositionYears?: number;
}

